import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';
import { PayBenchmarkingCompensationUnit } from 'libs/end-to-end/src/pay-benchmarking';
import { PayBenchmarkingRequest } from 'libs/end-to-end/src/custom-viz/PayBenchmarkingTypes';

export const constructPayBenchmarkingRequest = ({
  benchmark,
  department,
  role,
  level,
  location,
  experience,
  education,
  currency,
  compensationUnit,
  organizationId,
  observationLocationType,
}: {
  benchmark: string;
  department: string;
  role: string;
  level: string;
  location: string;
  experience: string | null;
  education: string | null;
  currency: string;
  compensationUnit: PayBenchmarkingCompensationUnit;
  organizationId: string;
  observationLocationType: ObservationLocationType;
}): PayBenchmarkingRequest => {
  return {
    customVizId: 'payBenchmarking',
    inputs: {
      dropdowns: {
        benchmark: [benchmark],
        department: [department],
        job_title: [role],
        job_level: [level],
        location: [location],
        experience: experience ? [experience] : [],
        education: education ? [education] : [],
        compensation_unit: [compensationUnit],
        currency: [currency],
      },
      extras: {},
    },
    observationLocationType,
    organizationId,
  };
};
